module.exports = __webpack_public_path__ + "static/media/pla_gra_cut.3e8b40a7.png";